import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { CollectionService } from '../../services/collection.service';
import { ReportType } from '../../services/collection.model';
@Component({
  selector: 'app-delete-collection',
  templateUrl: './delete-collection.component.html',
  styleUrls: ['./delete-collection.component.scss']
})
export class DeleteCollectionComponent implements OnInit {
  collection : any = {};
  savingInProgress: boolean;
  constructor(
    private dialogRef: MatDialogRef<DeleteCollectionComponent>,
    private collectionService: CollectionService,
  ) { }

  ngOnInit(): void {
    this.collection = this.dialogRef._containerInstance._config.data;
  }

  closePopup() {
    this.dialogRef.close();
  }

  deleteCollection() {
    this.savingInProgress = true;
    const updatedCollection = {
      ...this.collection,
      disabled: true,
      featureType: this.collectionService.getFeatureType(this.collection.featureType)
    }
    this.collectionService.updateCollection(updatedCollection)
    .subscribe((isSuccessful) => {
      this.savingInProgress = false;
      if (isSuccessful) {
        this.dialogRef.close();
        this.collectionService.showToast({
          type: 'success',
          title: 'Collection Deleted',
          message: `${this.collection.featureType} collection "${this.collection.featureName}" successfully deleted.`
        });
      } else {
        this.collectionService.showToast({
          type: 'error',
          title: 'Collection Not Deleted',
          message: `${this.collection.featureType} collection "${this.collection.featureName}" not deleted.`
        });
      }
    });
  }

}
